export const BOOKING_STATUS_LABELS = {
  pending: 'En attente',
  counter_offer: 'Contre-proposition',
  accepted: 'Accepté',
  rejected: 'Refusé',
  cancelled: 'Annulé',
};

export const BOOKING_STATUS_COLORS = {
  pending: 'border-status-pending text-status-pending bg-status-pending/10',
  counter_offer: 'border-status-pending text-status-pending bg-status-pending/10',
  accepted: 'border-accent text-accent bg-accent/10',
  rejected: 'border-status-rejected text-status-rejected bg-status-rejected/10',
  cancelled: 'th-border th-text-muted',
};
